import { render, staticRenderFns } from "./ApiErrorsReasonsTable.vue?vue&type=template&id=546a4b94&scoped=true&"
import script from "./ApiErrorsReasonsTable.vue?vue&type=script&lang=js&"
export * from "./ApiErrorsReasonsTable.vue?vue&type=script&lang=js&"
import style0 from "./ApiErrorsReasonsTable.vue?vue&type=style&index=0&id=546a4b94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546a4b94",
  null
  
)

export default component.exports